<template>
  <EditLabelSetting
    title="Edit Button Text"
    :modelKey="`public_advance_setting.${modelKey}`"
    :defaultValue="defaultValue"
    :classList="classList"
    tagName="button"
    :disabled="disabled"
    :additionalFields="convertedAdditionalFields"
    @click="$emit('click', $event)"
  />
</template>
<script>
export default {
  name: "EditButtonSetting",
  props: {
    modelKey: String,
    defaultValue: String,
    classList: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    additionalFields: Array,
  },
  computed: {
    convertedAdditionalFields() {
      if (!this.additionalFields) {
        return [];
      }
      return this.additionalFields.map((item) => ({
        ...item,
        modelKey: `public_advance_setting.${item.modelKey}`,
      }));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/EditButtonSetting.vue